import WdDialog from '@main/core/WdDialog';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import WdSuspense from '@main/core/WdSuspense';
import { memo } from 'react';
import { useRoutes } from 'react-router-dom';
import { selectWdNavbar } from 'app/store/core/navbarSlice';
import { selectWdCurrentLayoutConfig } from 'app/store/core/settingsSlice';
import FooterLayout1 from './components/FooterLayout1';
import LeftSideLayout1 from './components/LeftSideLayout1';
import NavbarWrapperLayout1 from './components/NavbarWrapperLayout1';
import RightSideLayout1 from './components/RightSideLayout1';
import ToolbarLayout1 from './components/ToolbarLayout1';
import NavbarToggleFab from '../shared-components/NavbarToggleFab';
import ModalsLayout1 from './components/ModalsLayout1';

const Root = styled('div')(({ theme, config }) => ({
  ...(config.mode === 'boxed' && {
    clipPath: 'inset(0)',
    maxWidth: `${config.containerWidth}px`,
    margin: '0 auto',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  }),
  ...(config.mode === 'container' && {
    '& .container': {
      maxWidth: `${config.containerWidth}px`,
      width: '100%',
      margin: '0 auto',
    },
  }),
}));

function Layout1(props) {
  const config = useSelector(selectWdCurrentLayoutConfig);
  const { routes } = useSelector((state) => state.routes);
  const navbar = useSelector(selectWdNavbar);

  return (
    <Root id="Wd-layout" config={config} className="w-full flex">
      {config.leftSidePanel.display && <LeftSideLayout1 />}

      <div className="flex flex-auto min-w-0">
        {config.navbar.display && config.navbar.position === 'left' && <NavbarWrapperLayout1 />}

        <main id="Wd-main" className="flex flex-col flex-auto min-h-full min-w-0 relative z-10">
          {config.toolbar.display && (
            <ToolbarLayout1 className={config.toolbar.style === 'fixed' && 'sticky top-0'} />
          )}

          {/* <div className="sticky top-0 z-99">
            <SettingsPanel />
          </div> */}

          <div className="flex flex-col flex-auto min-h-0 relative z-10">
            <WdDialog />

            <WdSuspense>{useRoutes(routes)}</WdSuspense>

            {props.children}
          </div>

          {config.footer.display && (
            <FooterLayout1 className={config.footer.style === 'fixed' && 'sticky bottom-0'} />
          )}
        </main>
        {config.navbar.display && config.navbar.position === 'right' && (
          <NavbarWrapperLayout1>
            {config.navbar.display && !config.toolbar.display && !navbar.open && (
              <NavbarToggleFab />
            )}
          </NavbarWrapperLayout1>
        )}
      </div>
      <ModalsLayout1 />

      {config.rightSidePanel.display && <RightSideLayout1 />}
    </Root>
  );
}

export default memo(Layout1);
